import { ENVIRONMENT } from '../config/environment';
import { deepConvertBigInt } from './deep-convert-bigint';
export async function slackLogger({ type, pkp, payload, }) {
    try {
        if (ENVIRONMENT == 'LOCAL') {
            return;
        }
        const webhookToUse = 'https://hook.us1.make.com/4mqg8x1qsr5eoefmwq97q460s5txsjv6';
        const body = {
            type: type,
            ethAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
            additionalEthAddress: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
            solanaAddress: pkp === null || pkp === void 0 ? void 0 : pkp.solanaAddress,
            payload: JSON.stringify(deepConvertBigInt(payload)),
        };
        const response = await fetch(`${webhookToUse}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return response;
    }
    catch (e) {
        console.log('Error in slackLogger', e);
    }
}
